import { assertNever } from "@redotech/util/type";

export enum SlideInPanelAnchorLocation {
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_MIDDLE = "BOTTOM_MIDDLE",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  TOP_LEFT = "TOP_LEFT",
  TOP_MIDDLE = "TOP_MIDDLE",
  TOP_RIGHT = "TOP_RIGHT",
}

export const getSlideInPanelAnchorLocationLabel = (
  anchorLocation: SlideInPanelAnchorLocation,
) => {
  switch (anchorLocation) {
    case SlideInPanelAnchorLocation.BOTTOM_LEFT:
      return "Bottom left";
    case SlideInPanelAnchorLocation.BOTTOM_MIDDLE:
      return "Bottom middle";
    case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
      return "Bottom right";
    case SlideInPanelAnchorLocation.TOP_LEFT:
      return "Top left";
    case SlideInPanelAnchorLocation.TOP_MIDDLE:
      return "Top middle";
    case SlideInPanelAnchorLocation.TOP_RIGHT:
      return "Top right";
    default:
      assertNever(anchorLocation);
  }
};
